import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';
import { API } from '../../utils/apiConfig';

export const AutocompleteInput = ({ field, value, onChange, placeholder, testId }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${API}/tournament-hub/meta/autocomplete`, { params: { field, q: value || '' } });
        setSuggestions(res.data.values || []);
      } catch (e) { /* silent */ }
    }, 250);
    return () => clearTimeout(timerRef.current);
  }, [value, field]);

  return (
    <div className="relative">
      <Input
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        data-testid={testId}
        autoComplete="off"
      />
      {open && suggestions.length > 0 && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
          {suggestions.map((s) => (
            <button
              key={s}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); onChange(s); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-amber-50 text-slate-700"
              data-testid={`${testId}-suggestion-${s}`}
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
